export const projectConfig = {
  port: 4400,
  host: 'localhost',
};
